import React from 'react'
import { useForm, Controller } from "react-hook-form";
import DropdownComponent from "../../../containers/Dropdown";
import * as utilities from "../../../utilities/utils";
import { useEffect, useState } from 'react';
import { Height } from 'devextreme-react/chart';
/**
* @author
* @function ReportModal
**/

const ReportModal = (props) => {
    const { register, control, handleSubmit, watch, formState: { errors }, setValue, getValues } = useForm();
    const [selectedModule, setSelectedModule] = useState([]);
    const [report, setReport] = useState([]);

    useEffect(() => {
        props.getAllCompanyList();
        props.getReportModule();
    }, [props.i18nReducerLang])

    useEffect(() => {
        utilities.extractFirstValueOfArray(selectedModule) && props.getAllReports(utilities.extractFirstValueOfArray(selectedModule));
    }, [selectedModule, props.i18nReducerLang])


    const {
        masterReport
    } = props.userAuthReducer;

    const onDropDownChange = (event) => {
        setSelectedModule(event.value);
        setValue('selectedModule', utilities.extractFirstValueOfArray(event.value))
        if (event.value.length <= 0) {
            props.resetAllReport();
        }
    }

    const onReportChange = (event) => {
        setReport(event.value);
        setValue('report', utilities.extractFirstValueOfArray(event.value));
    }
    return (
        <>
            <div className="modal-dialog modal-dialog-centered z-index-999" role="document">
                <div className="modal-content report-modal-height">
                    <div className="modal-header">
                        Assign Report To Company
                    </div>
                    <div className="modal-body">
                        <form
                            onSubmit={handleSubmit(props.handleSubmit)}
                        >
                            <div className="form-group">
                                <label>Select Module
                                    <span size="5" className="error-star">
                                        *
                                    </span>
                                </label>
                                {/* <DropdownComponent
                                    name="companyList"
                                    options={props.userAuthReducer.companyList}
                                    isMultiSelect={false}
                                    option_key="companyId"
                                    option_display="companyName"
                                    onChange={onDropDownChange}
                                    values={selectedModule}
                                    simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                    selectAllText="Select All Options"
                                    isSearchOption={true}
                                    searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                /> */}
                                <Controller
                                    {...register("selectedModule", { required: true, value: getValues("selectedModule") })}
                                    render={({ field }) =>
                                        <DropdownComponent
                                            name="companyList"
                                            options={props.userAuthReducer.reportModules}
                                            isMultiSelect={false}
                                            option_key="moduleId"
                                            option_display="moduleName"
                                            onChange={onDropDownChange}
                                            values={selectedModule}
                                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                            selectAllText="Select All Options"
                                            isSearchOption={true}
                                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                        />
                                    }
                                    name="selectedModule"
                                    control={control}
                                />
                                <small className="text-danger">{!selectedModule.length > 0 && errors.selectedModule?.type === 'required' && "Please select company"}</small>
                            </div>
                            <div>
                                {/* <select className="form-control form-control-lg"
                                    {...register("report", {
                                        required: true,
                                        value: report,
                                        onChange: onReportChange
                                    })}
                                >
                                    <option value="">-:Select Report:-</option>
                                    {
                                        masterReport && masterReport.length > 0 && masterReport.map((r) => (
                                            <option value={r.reportId}>{r.reportName}</option>
                                        ))
                                    }

                                </select> */}
                                <div className="form-group">
                                    <label>Select Report
                                        <span size="5" className="error-star">
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        {...register("report", { required: true, value: getValues("selectedModule") })}
                                        render={({ field }) =>
                                            <DropdownComponent
                                                name="reportList"
                                                options={masterReport}
                                                isMultiSelect={false}
                                                option_key="reportId"
                                                option_display="reportName"
                                                onChange={onReportChange}
                                                values={report}
                                                simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                                selectAllText="Select All Options"
                                                isSearchOption={true}
                                                searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                            />
                                        }
                                        name="report"
                                        control={control}
                                    />
                                    <small className="text-danger">{!report.length > 0 && errors.report?.type === 'required' && "Please select report"}</small>
                                </div>
                            </div>
                            <div className="text-right mt-2">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value="Submit"
                                />
                            </div>
                        </form>

                    </div>
                </div >
            </div >
        </>
    )
}


export default ReportModal